import { useQuery, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

export const getStrategies = async (endpoint, tableName, filters = {}) => {
  try {
    const url = `${baseUrl}${endpoint}`
    const { data } = await axios.get(url, {
      params: { table: tableName, ...filters }, // Pass filters for PK, SK, or EntityType
    })
    return data || []
  } catch (error) {
    console.error('Error fetching strategies:', error)
    return [] // Return an empty array in case of an error
  }
}

export const useStrategies = (enabled, queryKey = ['strategies']) => {
  const queryClient = useQueryClient()
  const existing = queryClient.getQueryData(queryKey)
  const { data: strategies, isLoading: isStrategiesLoading, isError: isStrategiesError } = useQuery({
    queryKey: queryKey,
    queryFn: () => getStrategies('/aws/strategy', 'strategy'),
    staleTime: Infinity, // Prevent the query from becoming stale
    gcTime: 1000 * 60 * 30, // Cache for 30 minutes
    refetchOnWindowFocus: false, // Prevent refetching when window regains focus
    refetchOnReconnect: false, // Prevent refetching when the network reconnects
    // enabled: enabled ?? false, // Keep this enabled for debugging
    enabled: !existing, // Keep this enabled for debugging
  })
  return { strategies, isStrategiesLoading, isStrategiesError }
}
